import * as React from 'react';
import cx from 'classnames';
import { Flex } from '@common/components/Flex';
import { I18n } from 'react-redux-i18n';
import { Button } from '@common/components/Button';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';

import './tabs.styles.scss';

export enum TabsItemType {
  questionnaireHome = 'questionnaireHome',
  configuration = 'configuration',
  emailAndReminders = 'emailAndReminders',
  statusActions = 'statusActions',
  questionnaireDesigner = 'questionnaireDesigner',
}

export type TabsProps = {
  errors?: Record<TabsItemType, boolean>;
  className?: string;
  value?: TabsItemType;
  onChange: (value: TabsItemType) => void;
};

export const Tabs: React.FC<TabsProps> = (props) => {
  const { className, value, errors, onChange } = props;
  const tabs = [
    {
      iconSrc: 'fa fa-home',
      label: 'Questionnaire Home',
      type: TabsItemType.questionnaireHome
    },
    {
      iconSrc: 'fa fa-gear',
      label: 'Configuration',
      type: TabsItemType.configuration
    },
    {
      iconSrc: 'fa fa-envelope',
      label: 'Email & Reminders',
      type: TabsItemType.emailAndReminders
    },
    {
      iconSrc: 'fa fa-arrow-circle-right',
      label: 'Status Actions',
      type: TabsItemType.statusActions
    },
    {
      iconSrc: 'fa fa-edit',
      label: 'Questionnaire Designer',
      type: TabsItemType.questionnaireDesigner
    },
  ].map(({ label, ...restData }) => ({ 
    ...restData, 
    label: I18n.t(label),
  }));

  const handleChange = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    onChange(e.currentTarget.dataset.type as TabsItemType);
  }, [onChange]);

  return (
    <Flex 
      className={cx(
        'FhqDesignToolQuestionnaireManagementTabs', 
        className
      )}
    >
      {tabs.map(({ iconSrc, label, type, ...btnProps }) => (
        <Button
          key={type}
          className={cx(
            "FhqDesignToolQuestionnaireManagementTabs__btn",
            { 
              'FhqDesignToolQuestionnaireManagementTabs__btn--selected': type === value,
              'FhqDesignToolQuestionnaireManagementTabs__btn--has-error': errors ? errors[type] : false,
            }
          )}
          {...getTestAttributes(MODULE_NAME, 'tab', 'button', label.toLowerCase().replace(' ', '-'))}
          {...btnProps}
          data-type={type}
          onClick={handleChange}
        >
          <i className={iconSrc} />
          {I18n.t(label)}
        </Button>
      ))}
    </Flex>
  );
};